var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 54a10.12 10.12 0 0010-10.24c0-6.86-8.12-13.9-10-21.76-1.88 7.86-10 14.9-10 21.76A10.119 10.119 0 0038 54z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/BZ_Water.74d22d3e.svg";
export { SvgBzWater as ReactComponent };